<template>
  <div>
    <div class="header-container">
      <div class="header">
        <router-link :to="'main'" tag="h1">LeeJaeHa Architects</router-link>
        <div class="project-info" :style="{visibility: showInfo ? 'visiblie' : 'hidden'}">
          <h2 class="project-name">{{ prjName }}</h2>
          <!-- <span class="text-show">Read more</span> -->
          <span class="photo-count">{{ crrNum }} / {{ photoNum }}</span>
        </div>
        <span class="contact" @click="popupShow">Contact</span>
      </div>
    </div>
    <div class="project-text">
      <p>{{ prjText }}</p>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus.js";

export default {
  props: {
    crrNum: Number,
    photoNum: Number,
    showInfo: Boolean,
    prjName: String
  },
  data: function() {
    return {
      popupState: false,
      prjText:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. "
    };
  },
  mounted() {
    // if (this.showInfo == true) {
    //   document.querySelector(".photo-count").style.visibility = "visible";
    // }
  },
  methods: {
    popupShow: function() {
      // this.popupState = true;
      EventBus.$emit("use-eventbus");
    }
  }
};
</script>

<style>
</style>
